import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'


import './Articles.css'

const useStyles = makeStyles((theme) => ({
    textColor: {
        color: theme.palette.text.primary,
    },
    spacerText: {
        padding: theme.spacing(1),
    },
  }))



const ArticlesThree = () => {

    const classes = useStyles()

    return (
            <Link className={classes.textColor} to="/artigos-particulares">
                <article className="secundario">
                    <img className='imagem-dos-artigos' src={'https://blog.bullseye.com.br/wp-content/uploads/2021/08/pexels-snapwire-6945-1024x768.jpg'} alt="flash"/>
                    <h1 className={classes.spacerText}>Independência Financeira</h1>
                    <p className={classes.spacerText}>A Independência Financeira é o sonho de muitas pessoas que começam a investir, mas muitos não têm um plano bem definido para alcançar este objetivo, entenda agora o que é a independência financeira e como alcançá-la!</p>
                </article>
            </Link>
    )
    
}

export default ArticlesThree